// JS cell renderer to improve performance
import { ICellRendererParams } from 'ag-grid-community';

export class OptimizedExclamationIconCellRenderer {
  private eGui!: HTMLDivElement;
  private cellValue!: string;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');

    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue || '';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue;

    return true;
  }


  // eslint-disable-next-line class-methods-use-this
  getValueToDisplay(params: ICellRendererParams) {
    const { value } = params;

    if (value) {
      return `
      <span>
        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512" class="text-danger optimized-exclamation-icon-cell-renderer">
          <path d="M64 352c17.69 0 32-14.32 32-31.1V64.01c0-17.67-14.31-32.01-32-32.01S32 46.34 32 64.01v255.1C32 337.7 46.31 352 64 352zM64 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S86.09 400 64 400z"/>
        </svg>
        ${value}
      </span>
      `;
    }

    return '';
  }
}
